import React from "react";
import PageTemplate from "../components/PageTemplate";

function Appetizers() {
  return (
    <PageTemplate title="Appetizers">
      <p>Small bites with big flavor — appetizer ideas coming soon!</p>
    </PageTemplate>
  );
}

export default Appetizers;
